import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLinkItem,
  DropdownMenuTrigger,
} from '@shared/components/ui/dropdown-menu';
import { faCreditCard, faEllipsisVertical, faMoneyBill, faWallet } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@shared/components/ui/button';
import { usePermissions } from '@shared/hooks/usePermissions';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const WalletNavigationDropdown: FC = () => {
  const { t } = useTranslation('walletsModule');
  const location = useLocation();
  const { canAccess } = usePermissions();

  const isExternal = canAccess(['tenant_external'], []);
  const canViewBankAccounts = canAccess(['tenant_external'], ['bank-accounts.view']);
  const canViewWithdrawals = canAccess(['tenant_external'], ['withdrawals.view']);
  const canViewTopups = canAccess(['tenant_external'], ['topups.view']);

  // Solo mostrar para tenant_external
  if (!isExternal) {
    return null;
  }

  const navigationItems = [
    {
      id: 'bank-accounts',
      label: t('navigation.bankAccounts'),
      path: '/wallets/bank-accounts',
      icon: faCreditCard,
      show: canViewBankAccounts,
    },
    {
      id: 'withdrawals',
      label: t('navigation.withdrawals'),
      path: '/wallets/withdrawals',
      icon: faMoneyBill,
      show: canViewWithdrawals,
    },
    {
      id: 'topups',
      label: t('navigation.topups'),
      path: '/wallets/topups',
      icon: faWallet,
      show: canViewTopups,
    },
  ].filter((item) => item.show);

  if (navigationItems.length === 0) {
    return null;
  }

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="bg-card-bg">
          <FontAwesomeIcon icon={faEllipsisVertical} className="!w-3 !h-3" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-52 border-card-border">
        {navigationItems.map((item) => {
          const active = isActive(item.path);
          return (
            <DropdownMenuLinkItem
              key={item.id}
              to={item.path}
              className={active ? 'bg-sidebar-accent text-sidebar-accent-foreground' : undefined}
            >
              <FontAwesomeIcon icon={item.icon} className="mr-2 w-3.5" />
              {item.label}
            </DropdownMenuLinkItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
